import { render } from "./AccountRecoverySuccessDialog.vue?vue&type=template&id=53d8b302"
import script from "./AccountRecoverySuccessDialog.vue?vue&type=script&lang=js"
export * from "./AccountRecoverySuccessDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__